export { default as ItemsTab } from './items.vue'
export { default as PaymentTab } from './payment.vue'
export { default as ShippingTab } from './shipping.vue'
export { default as MemberInformationTab } from './MemberInformationTab'
export { default as MemberAddressesTab } from './MemberAddressTab.vue'
export { default as MemberIdImagesTab } from './MemberImagesTab'
export { default as CorporateDetail } from './corporateDetail.vue'
export { default as CardInformation } from './cardInformation.vue'
export { default as InstallationDetail } from './installationDetail.vue'
export { default as RentalSalesDocuments } from './MemberRentalSalesDocuments.vue'
export { default as MemberMaritalStatus } from './memberMaritalStatus.vue'
export { default as MemberBankInfoTab } from './MemberBankInfo.vue'
